import template from './operations.html';
import controller from './operations.controller';

let operationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationsComponent;
